import { IS_HEBREW, LOCALES } from './locale';

export const InputMask = {
  DATE: '9999',
  PHONE: IS_HEBREW ? '59-999-9999' : '(999) 999-9999',
};

export const InputMaxLength = {
  EMAIL: 254,
  TEXT: 512,
};

export const InputMinLength = {
  MESSAGE: 5,
  TEXT: 2,
};

export enum InputType {
  COUNTRY_CODE = 'country-code',
  EMAIL = 'email',
  FIRST_NAME = 'first-name',
  LAST_NAME = 'last-name',
  MESSAGE = 'message',
  NAME = 'name',
  PHONE = 'phone',
  SELECT = 'select',
  YEAR = 'year',
}

export const InputTextError = {
  EMAIL_FORMAT: LOCALES.EMAIL_FORMAT,
  FIRST_NAME_MIN_LENGTH: LOCALES.FIRST_NAME_MIN_LENGTH,
  LAST_NAME_MIN_LENGTH: LOCALES.LAST_NAME_MIN_LENGTH,
  MESSAGE_MIN_LENGTH: LOCALES.MESSAGE_MIN_LENGTH,
  NAME_MIN_LENGTH: LOCALES.NAME_MIN_LENGTH,
  PHONE_FORMAT: LOCALES.PHONE_FORMAT,
  YEAR_LATER: LOCALES.YEAR_LATER,
};
